// utils/normalizeResultSheet.js
export function normalizeResultSheet(rawArray) {
  if (!Array.isArray(rawArray) || rawArray.length === 0) {
    return { meta: null, rows: [] };
  }

  const first = rawArray[0];
  const test = first.monthlyTest ?? {};

  const meta = {
    schoolName: first.schoolName ?? 'School',
    address: first.address ?? '',
    logo: first.logo ?? '',
    academicYear: first.academicYear ?? test.academicYear ?? '',
    testName: test.testName ?? first.testName ?? '-',
    subject: test.subject ?? first.subject ?? '',
    standard: test.standard ?? first.standard ?? '',
    section: test.section ?? first.section ?? '',
    testDate: test.testDate ?? first.testDate ?? null,
    maxMarks: test.maxMarks ?? first.maxMarks ?? 0,
    passingMarks: test.passingMarks ?? first.passingMarks ?? 0,
    status: test.status ?? first.status ?? '',
    monthlyTestId: test.id ?? null,
  };

  const rows = [];
  rawArray.forEach((group) => {
    const groupTestName =
      group.testName ??                       // prefer explicit testName if present
      group.monthlyTest?.testName ??
      `${group.subject ?? ''} Test`;          // fallback

    (group.marks ?? []).forEach((mark) => {
      const obtained = mark.absent ? 0 : (mark.marksObtained ?? 0);
      const maxMarks = group.maxMarks ?? 0;
      const passing = group.passingMarks ?? 0;
      const percentage =
        maxMarks > 0 && !mark.absent
          ? Math.round((obtained / maxMarks) * 1000) / 10
          : 0;

      rows.push({
        seq: rows.length + 1,
        marksId: mark.id,
        monthlyTestId: mark.monthlyTestId ?? group.id,
        studentId: mark.studentId,
        rollNumber: mark.rollNumber,
        studentName: mark.studentName,

        // Test info comes from the GROUP, not the mark
        testName: groupTestName,
        subject: group.subject ?? '',
        testDate: group.testDate ?? null,
        status: group.status ?? '',
        maxMarks,
        passingMarks: passing,

        // Mark info
        marksObtained: obtained,
        grade: mark.grade ?? '-',
        absent: !!mark.absent,
        remarks: mark.remarks ?? '',

        percentage,
        result: mark.absent
          ? 'ABSENT'
          : obtained >= passing
            ? 'PASS'
            : 'FAIL',
      });
    });
  });

  return { meta, rows };
}

export function computeStats(rows, passingMarks) {
  const total = rows.length;
  const absent = rows.filter(r => r.absent).length;
  const present = rows.filter(r => !r.absent);
  const passed = present.filter(r => r.marksObtained >= passingMarks).length;
  const failed = present.length - passed;

  const avg = present.length
    ? present.reduce((s, r) => s + r.marksObtained, 0) / present.length
    : 0;
  const highest = present.length
    ? Math.max(...present.map(r => r.marksObtained))
    : 0;
  const lowest = present.length
    ? Math.min(...present.map(r => r.marksObtained))
    : 0;

  return {
    total,
    absent,
    appeared: present.length,
    passed,
    failed,
    passPercentage: present.length
      ? Math.round((passed / present.length) * 1000) / 10
      : 0,
    average: Math.round(avg * 100) / 100,
    highest,
    lowest,
  };
}